import Image5 from "../../assets/hanna.png"

export const projectsData = [
  {
    id: 1,
    title: "E-Learning Website",
    description: "A full-stack e-learning platform built with React and Node.js featuring user authentication, course management, and payment integration.",
    technologies: ["React", "Node.js", "MongoDB", "Express", "PayStack"],
    github: "https://https://github.com/Editor9948/Hannacode",
    demo: "https://www.hannacode.com",
    image: Image5
  }
];